import React, { createContext, useContext } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

// Define common media query breakpoints
// // this are old ones for reference when we are refactoring old code to use
// context
// export const FIRST_MEDIA_QUERY = '(min-width:1025px)';
// export const SECOND_MEDIA_QUERY = '(min-width:768px)';
const MEDIA_QUERY_VALUES = {
    XS: '(max-width: 376px)',
    SM: '(min-width: 376px) and (max-width: 768px)',
    MD: '(min-width: 768px) and (max-width: 1280px)',
    LG: '(min-width: 1280px) and (max-width: 1920px)',
    XL: '(min-width: 1920px)',
};

// Create the context
const MediaQueryContext = createContext();

// Create a provider component
export const MediaQueryProvider = ({ children }) => {
    const IS_XS = useMediaQuery(MEDIA_QUERY_VALUES.XS);
    const IS_SM = useMediaQuery(MEDIA_QUERY_VALUES.SM);
    const IS_MD = useMediaQuery(MEDIA_QUERY_VALUES.MD);
    const IS_LG = useMediaQuery(MEDIA_QUERY_VALUES.LG);
    const IS_XL = useMediaQuery(MEDIA_QUERY_VALUES.XL);
    const IS_DESKTOP = IS_LG || IS_XL;
    const IS_MOBILE = IS_SM || IS_XS;

    const mediaQueryValues = {
        IS_XS,
        IS_SM,
        IS_MD,
        IS_LG,
        IS_XL,
        IS_DESKTOP,
        IS_MOBILE,
    };

    return (
        <MediaQueryContext.Provider value={mediaQueryValues}>
            {children}
        </MediaQueryContext.Provider>
    );
};

// Custom hook to use the MediaQueryContext
export const useMediaQueryContext = () => {
    const context = useContext(MediaQueryContext);
    if (!context) {
        throw new Error('useMediaQueryContext must be used within a MediaQueryProvider');
    }
    return context;
};
